var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12"},[_c('px-card',{attrs:{"title":"Sales Status"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('orderChart'),_c('location-chart'),_c('revenueChart')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }